import * as z from "zod/v4";

export const startCodeSearch = {
  name: "startCodeSearch" as const,
  input: z.object({
    triageThreadId: z.string().describe("The AI triage thread ID"),
    escalationReason: z
      .string()
      .optional()
      .describe("Reason for escalation from AI agent"),
    issueCategory: z
      .string()
      .optional()
      .describe("Category of issue from AI agent"),
    customerContext: z
      .string()
      .nullable()
      .optional()
      .describe("Additional context from AI agent"),
  }),
  output: z.object({
    investigationId: z.string(),
    noticeTopic: z
      .string()
      .describe("Notice topic for real-time result delivery"),
  }),
};
